// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150903/js/" + chunkId + "." + {"44":"31dfe3a6","225":"d4418245","481":"c539226a","486":"2ffd2ebb","770":"72e7a362"}[chunkId] + ".0.975600434341251.chunk.js";
};